import { render, staticRenderFns } from "./LessonBatch.vue?vue&type=template&id=6f84c9df&scoped=true"
import script from "./LessonBatch.vue?vue&type=script&lang=js"
export * from "./LessonBatch.vue?vue&type=script&lang=js"
import style0 from "./LessonBatch.vue?vue&type=style&index=0&id=6f84c9df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84c9df",
  null
  
)

export default component.exports